import { useState } from 'react';
import { Debounce } from '../components/debounce.js';

const PlacesPage = ({ passData }) => {
  const [useTool, setUseTool] = useState(false);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ textAlign: 'center', width: '100%', maxWidth: '700px', padding: '0 5vw' }}>
        <img style={{ padding: '0px 0px 20px 0px', maxWidth: 'min(350px, 80vw)', width: '100%', marginTop: '20px' }}
          src="https://empirefences.com/wp-content/uploads/2026/05/ef-logo-2.png" alt="Company Logo"
        />
        <div style={{ textAlign: 'center', color: 'black' }}>
          {!useTool ? (
            <>
              <img style={{ width: 'min(280px, 80vw)', marginBottom: '10px', borderRadius: '12px' }}
                src="https://empirefences.com/wp-content/uploads/2024/03/fenceDrawingIcon.webp" alt="Example fence drawing"
              />
              <p style={{ fontSize: 'clamp(20px, 2.5vw, 24px)', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
                Ready to get fence estimate?
              </p>
              <p style={{ fontSize: 'clamp(17px, 2vw, 21px)', margin: '0 auto 12px auto', maxWidth: 'min(320px, 80vw)', color: '#444', lineHeight: '1.5' }}>
                Our app lets you draw fence lines directly onto your property using Google Maps — allowing you to easily get a free fence quote!
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexDirection: 'column', marginTop: '20px', marginBottom: '24px', flexWrap: 'wrap', alignItems: 'center' }}>
                <button
                  onClick={() => setUseTool(true)}
                  style={{ padding: 'clamp(10px, 1.2vw, 13px) clamp(20px, 2.5vw, 26px)', borderRadius: '10px', fontSize: 'clamp(16px, 1.8vw, 19px)', fontWeight: '600', cursor: 'pointer', backgroundColor: 'maroon', color: 'white', transition: 'all 0.2s', width: 'min(260px, 70vw)'}}
                >
                  🗺️ Click Here to Start
                </button>
              </div>
            </>
          ) : (
            <>
              <br />
              <button
                onClick={() => setUseTool(false)}
                style={{ marginTop: '16px', padding: 'clamp(8px, 1vw, 11px) clamp(18px, 2vw, 22px)', borderRadius: '10px', fontSize: 'clamp(15px, 1.6vw, 17px)', fontWeight: '600', cursor: 'pointer', backgroundColor: '#fff', color: '#620d0e', border: '2px solid #620d0e', transition: 'all 0.2s' }}
              >
                ← Back
              </button>
              <h2 style={{ fontSize: 'clamp(20px, 2.5vw, 24px)' }}>Type Address Below & Select</h2>
              <Debounce passData={passData} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlacesPage;